import React from 'react';

const NotFound = ()=> {
	return (
		<div style={{textAlign:'center',paddingTop:'3em'}}>
			<h2 style={{fontSize:'200%'}}>Not Found</h2>
			<div style={{color:'#666666'}}>ページが見つかりません！<br/>不思議！</div>
		</div>
	)
}

export default NotFound;